import $ from "jquery";

$("button.sb_review-item_btn-more-text").on("click tap", function () {
	$(this).closest(".sb_review-item").addClass("s_show-text");
	window.dispatchEvent(new Event("resize"));
});

$("button.sb_review-item_btn-less-text").on("click tap", function () {
	$(this).closest(".sb_review-item").removeClass("s_show-text");
	window.dispatchEvent(new Event("resize"));
});
